import { useEffect } from 'react';
import type { DirectFcfsOrganizationApiNotificationConfig } from 'src/apis/direct-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

const organisationApiUrl =
  PRISMA_CONFIG.directFcfs + '/organisation-api-configuration';

export function useOrganizationApiNotificationConfig() {
  const organizationApiNotificationConfig = useAxios(
    (axios, baseConfig) =>
      axios.request<DirectFcfsOrganizationApiNotificationConfig>({
        ...baseConfig,
        url: organisationApiUrl,
        method: 'GET',
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    organizationApiNotificationConfig.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return organizationApiNotificationConfig;
}

export type OrganizationApiNotificationConfigRequest = ReturnType<
  typeof useOrganizationApiNotificationConfig
>;
